import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';

const StyledRaisedButton = styled(RaisedButton)`
    margin-right: 20px;

    &:last-child {
        margin-right: 0;
    }
`;

const DialogButton = (props) => {
    const {
        icon,
        keyboardFocused,
        label,
        onTouchTap,
        primary,
        style,
    } = props;

    return <StyledRaisedButton
        icon={ icon }
        keyboardFocused={ keyboardFocused }
        label={ label }
        onTouchTap={ onTouchTap }
        primary={ primary }
        style={ style }
    />;
};

DialogButton.propTypes = {
    icon: PropTypes.element,
    keyboardFocused: PropTypes.bool,
    label: PropTypes.string,
    onTouchTap: PropTypes.func,
    primary: PropTypes.bool,
    style: PropTypes.object,
};

export default DialogButton;



// WEBPACK FOOTER //
// ./src/components/button/DialogButton.js